module.exports = __webpack_public_path__ + "static/media/glass_show11.7f961dbf.jpg";